import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(public)/homepage/ProductsHero.tsx");
